import { render } from "./themeSwitcher.vue?vue&type=template&id=f34663de&scoped=true"
import script from "./themeSwitcher.vue?vue&type=script&lang=js"
export * from "./themeSwitcher.vue?vue&type=script&lang=js"

import "./themeSwitcher.vue?vue&type=style&index=0&id=f34663de&scoped=true&lang=scss"

import exportComponent from "/builds/simply-frontend/simply-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f34663de"]])

export default __exports__